import axios from 'axios'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useState } from 'react'
import Body from '~/components/typography/Body'
import Background from '../../components/Background'
import Button from '../../components/Button.js'
import Input from '../../components/form/Input.js'
import OverlayContent from '../../components/OverlayContent'

export default function Index(props) {
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [successMessage, setSuccessMessage] = useState(false)

  const router = useRouter()

  const requestResetLink = (e) => {
    e.preventDefault()
    setDisabled(true)
    axios
      .post(`${process.env.base_api}/auth/password-reset`, {
        email: email
      })
      .then(function (response) {
        console.log(response)
        setErrors([])
        setSuccessMessage(true)
        // router.push('/dashboard')
      })
      .catch(function (error) {
        const { data } = error.response
        setDisabled(false)
        setErrors(data.errors)
      })
  }
  const updateEmail = (evt) => {
    setEmail(evt.target.value)
  }
  const updatePassword = (evt) => {
    setPassword(evt.target.value)
  }

  return (
    <Background>
      <Head>
        <title>Request a password reset | KwizzBit</title>
      </Head>
      <div className="container">
        <button
          className="flex items-center m-20 text-white"
          onClick={() => router.back()}
        >
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
            <circle cx="15" cy="15" r="14" stroke="white" strokeWidth="2" />
            <path
              d="M17.2566 9.41082C17.582 9.73626 17.582 10.2639 17.2566 10.5893L12.8458 15.0001L17.2566 19.4108C17.582 19.7362 17.582 20.2639 17.2566 20.5893C16.9312 20.9147 16.4035 20.9147 16.0781 20.5893L11.0781 15.5893C10.7526 15.2639 10.7526 14.7362 11.0781 14.4108L16.0781 9.41082C16.4035 9.08539 16.9312 9.08539 17.2566 9.41082Z"
              fill="white"
            />
          </svg>
          <span className="ml-5">Back</span>
        </button>
      </div>
      <div className="flex flex-col justify-end md:justify-center flex-1 h-full">
        <OverlayContent>
          <form onSubmit={requestResetLink}>
            <Input
              onChange={updateEmail}
              type="email"
              label="Email"
              error={errors.email ?? ''}
              value={email}
              placeholder="Your email"
            />
            {successMessage && (
              <Body small className="mb-20">
                Please check your email. If the provided email address exists we
                have sent you instructions on how to reset your password
              </Body>
            )}
            <div className="md:flex justify-center items-center">
              <Button
                className="md:mx-10"
                onClick={requestResetLink}
                label="Request password reset link"
                disabled={disabled}
              />
            </div>
          </form>
        </OverlayContent>
      </div>
    </Background>
  )
}
